/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Row, Input, Space, Badge, Switch } from "antd";
import qs from "qs";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { EditFilled, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import Layout from "../../components/Layout";
import noDataLogo from "../../assets/images/no-data.png";
import color from "../../theme/color";
import { customBaseUrl, httpDelete, httpGet, httpPost, httpPut } from "../../store/http";
import { styled } from "@mui/material/styles";
import {
  Box,
  Select,
  Grid,
  Paper,
  MenuItem,
  FormControl,
  InputBase,
  Stack,
  IconButton,
} from "@mui/material";
import useMatStyles from "./styles";
import { transformName } from "../../utils/helper";
import { hideLoader, showLoader } from "../../utils/loader";
import { useTheme } from "styled-components";
import TemporalPeriodModal from "../../components/Modal/TransferToNonWayaUser/TemporalPeriod";
import NewTerm from "./newTerms";
import { DeleteOutline } from "@mui/icons-material";
import EditTerm from "./editTerm";
import Swal from "sweetalert2";

const TermsCondition = () => {
  const theme = useTheme();
  const matclasses = useMatStyles({ theme });
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
  });
  const styles = useMatStyles();
  const [search, setSearch] = useState({
    searchBy: "status",
    searchText: "",
  });
  const [totalTerms, setTotalTerms] = useState(0);
  const [allTerms, setAllTerms] = useState([]);
  const [showNewTerm, setShowNewTem] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState({})
  const getTerms = async (page, size) => {
    setAllTerms([]);
    showLoader();
    const pages = page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;

    let request = await httpGet(
      `${customBaseUrl.contentManagementUrl}/terms-and-condition?page=${pages}`
    );
    if (request.status) {
      hideLoader();
      setAllTerms(request.data.termsAndConditionResponses);
      setTotalTerms(request.data.totalNumberOfTermsAndCondition);
    } else {
      hideLoader();
    }
    hideLoader();

  };


  useEffect(() => {
    getTerms();
  }, []);



  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getTerms(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getTerms(newPage, pagination.pageSize);
  };

  const handleAct = async (id, state) => {
    showLoader();
    let res = await httpPut(`${customBaseUrl.contentManagementUrl}/terms-and-condition/${id}/activate`)

    if (res?.status) {
      hideLoader()
      Swal.fire('Done', state ? "Deactivated" : "Activated")
      await getTerms();
    } else {
      hideLoader()
      Swal.fire('Error', res?.message)
      await getTerms();
    }

  }


  var searchInput = useRef({});
  const columns = [

    {
      field: 'content',
      headerName: 'Terms and Conditions',
      width: 800,
      headerClassName: styles.tableHeader

    },

    {
      field: 'id',
      headerName: "Action ",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => <><IconButton onClick={() => { setSelectedRow(row); setShowEdit(true) }}><EditFilled /></IconButton><Switch defaultChecked={row?.active} onClick={() => handleAct(row.id, row?.active)} />  </>,
    }

  ];


  return (
    <Layout>

      <div style={tool}>
        {/*<select
          className={styles.selectType}
          defaultValue="disabled"
          onChange={(event) => {
            setSearch({ ...search, searchBy: event.target.value });
          }}
        >
          <option value="disabled" disabled>
            Search By...
          </option>
          {columns
            .filter((x) => x.headerName !== ("ACTION"&&"AMOUNT"))
            .map((header) => (
              <option value={header.field}>
                {transformName(header.headerName)}
              </option>
            ))}
        </select>
        {/*<div className={styles.searchRow}>
        <Input
            className={styles.searchInput}
            placeholder="Search Users by Name, Email or Date"
            onChange={(event) => {
              setSearch({ ...search, searchText: event.target.value });
            }}
            prefix={<SearchOutlined className={styles.searchIcon} />}
          />
          </div>*/}
        <div></div>
        <Row type="flex" justify="end" align="middle">

          <Button
            onClick={() => setShowNewTem(true)}
            size="medium"
            style={{ background: "#FF4B01", fontSize: "10px", color: "#fff" }}
          >
            <PlusOutlined />
            New Term and Condition
          </Button>
        </Row>
      </div>






      <Card style={{ background: "transparent" }}>
        <Card.Grid style={gridStyle} className="mr-2">
          <p>All Terms and Conditions</p>
          <h2 className="text-left">{totalTerms}</h2>
        </Card.Grid>

      </Card>

      <Grid
        style={{ marginTop: "10px" }}
        container
        spacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 4 }}
      ></Grid>
      <Card style={{ background: "transparent" }}>
        <Card.Grid style={tableGridStyle} className="mr-2">
          {allTerms.length ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                className={styles.table}
                density="comfortable"
                rows={allTerms}
                columns={columns}
                page={pagination.current}
                paginationMode="server"
                pageSize={pagination.pageSize}
                onPageSizeChange={(newPageSize) =>
                  handleChangeRowsPerPage(newPageSize)
                }
                onPageChange={(newPage) => handleChangePage(newPage)}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                pagination
                components={{ Toolbar: GridToolbar }}
                rowCount={totalTerms}

              />
            </div>
          ) : (
            <>
              <Row
                type="flex"
                justify="center"
                align="middle"
                className="mt-5"
                style={{ minHeight: "40vh" }}
              >
                <img src={noDataLogo} alt="nodata" style={{ height: "300px" }} />
              </Row>
              <h4 className="mt-3 text-center">No Request yet</h4>
              <p className="mt-3 text-center" style={{ color: color.textGray }}>
                Request will appear here when you
              </p>
            </>
          )}
        </Card.Grid>

      </Card>

      {showNewTerm && <NewTerm
        setShowModal={setShowNewTem}
        showModal={showNewTerm}
        getTerms={getTerms}
        className={styles.modal}
      />
      }
      {showEdit && <EditTerm
        setShowModal={setShowEdit}
        showModal={showEdit}
        getTerms={getTerms}
        content={selectedRow.content}
        id={selectedRow.id}
        className={styles.modal}
      />
      }
    </Layout>
  );
};

const gridStyle = {
  width: "23%",
  textAlign: "left",
  backgroundColor: "#fff",
  padding: "24px 10px 24px 12px",
  fontWeight: "bold",
  marginLeft: "10px",
};
const tableGridStyle = {
  width: "100%",
  textAlign: "left",
  backgroundColor: "#fff",
  padding: "24px 10px 24px 12px",
  fontWeight: "bold",
  marginLeft: "10px",
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export default TermsCondition;
